import { InferType } from 'yup';
import yup from '../../../../../utils/custom-yup';

// PS 閲覧・追加・編集・比較画面用。

// yup.object({}) と yup.object().shape({}) の違い:
// https://stackoverflow.com/questions/61991469/what-does-the-shape-function-do-in-yup
// You can also pass a shape to the object constructor as a convenience.
// Basically passing the schema to shape() is just the long-form of passing it to the object() constructor.
// shape() does however offer the benefit of chaining and overloading definitions in later chained methods.

// バリデーション用、且つ PS ツリーの検索条件のデフォルト値用。
/** API の postPsTreeSearch に渡す検索条件 PsTreeSearchConditions 用の yup の Schema。 */
export const psTreeSearchConditionsSchema = yup.object().shape(
  // PsTreeSearchConditions の定義は /src/openapi/CMS-POC_WebAPI.yaml の PsTreeSearchConditions と、/src/frontend/app/src/api/model/psTreeSearchConditions.ts を参照。
  // 検索条件のデフォルト値は、仕様書に記載されている場合はその値とし、そうでない場合はそれぞれの型の予想される初期値 (boolean なら false、string なら '' (空文字列) など) とする。
  {
    // include_title_ps_group?: boolean;
    /** タイトルPSグループを含むフラグ */
    // [psTreeSearchConditionsPropertyNames[0]]: yup.boolean().default(false),
    include_title_ps_group: yup.boolean().default(false),
    // freeword?: string;
    /** フリーワード検索 */
    freeword: yup.string().default(''),
    // ↓ 空文字列 ('') は「すべて」とみなす。
    // chapter_ps_id?: string;
    /** 章PSID */
    chapter_ps_id: yup.string().default(''),
    // title_only?: boolean;
    /** タイトルのみフラグ */
    title_only: yup.boolean().default(false),
    // level_from?: number;
    /** 表示するレベル開始(1:L1,2:L2,3:L3,4:L4,5:L5) */
    level_from: yup.number().default(1),
    // level_to?: number;
    /** 表示するレベル終了(1:L1,2:L2,3:L3,4:L4,5:L5) */
    level_to: yup.number().default(5),
    // ps_state_approved?: boolean;
    /** 承認済みフラグ */
    ps_state_approved: yup.boolean().default(false),
    // ps_state_request?: boolean;
    /** 申請中フラグ */
    ps_state_request: yup.boolean().default(false),
    // ps_state_deleted?: boolean;
    /** 廃止済みフラグ */
    ps_state_deleted: yup.boolean().default(false),
    // text_type_danger?: boolean;
    /** 記載条件分類 危険 */
    text_type_danger: yup.boolean().default(false),
    // text_type_warning?: boolean;
    /** 記載条件分類 警告 */
    text_type_warning: yup.boolean().default(false),
    // text_type_caution?: boolean;
    /** 記載条件分類 注意 */
    text_type_caution: yup.boolean().default(false),
    // text_type_notice?: boolean;
    /** 記載条件分類 アドバイス */
    text_type_notice: yup.boolean().default(false),
    // ps_nos?: string[];
    /** PS管理No.の配列 */
    ps_nos: yup.array().of(yup.string().ensure()).default([]),
    // ↓ 半角英数字記号。
    // half() は /src/frontend/app/src/index.tsx の yup.addMethod 時に追加されるため、ここでは使用できない。実際に使われる際 (yupResolver() の引数に渡す前) に定義し直す。
    // derivation_texts: yup.array().of(yup.string().half()).default([]),
    // derivation_texts?: string[];
    /** 派生文書テキストの配列 */
    derivation_texts: yup.array().of(yup.string()).default([]),
    // derivation_search_type?: number;
    /** 派生文書検索種別(0:AND,1:OR) */
    derivation_search_type: yup.number().default(0),
    // legal_ps?: boolean;
    /** 法規対象PS */
    legal_ps: yup.boolean().default(false),
    // legal_infos?: string[];
    /** 法規検索テキストの配列 */
    legal_infos: yup.array().of(yup.string()).default([]),
    // legal_region_ids?: number[];
    /** 法規適用国IDの配列 */
    legal_region_ids: yup.array().of(yup.number()).default([]),
    // text_conditions?: string[];
    /** テキスト確定条件の配列 */
    text_conditions: yup.array().of(yup.string()).default([]),
    // text_condition_search_type?: number;
    /** テキスト確定条件検索種別(0:AND,1:OR) */
    text_condition_search_type: yup.number().default(0),
    // judgement_infos?: string[];
    /** 判断情報の配列 */
    judgement_infos: yup.array().of(yup.string()).default([]),
    // judgement_info_search_type?: number;
    /** 判断情報検索種別(0:AND,1:OR) */
    judgement_info_search_type: yup.number().default(0),
    // date() は /src/frontend/app/src/index.tsx の yup.addMethod 時に追加されるため、ここでは使用できない。実際に使われる際 (yupResolver() の引数に渡す前) に定義し直す。
    // update_at_from?: string;
    // update_at_from: yup.string().date().default(''),
    /** 最終更新日開始 */
    update_at_from: yup.string().default(''),
    // date() は /src/frontend/app/src/index.tsx の yup.addMethod 時に追加されるため、ここでは使用できない。実際に使われる際 (yupResolver() の引数に渡す前) に定義し直す。
    // update_at_to?: string;
    // update_at_to: yup.string().date().default(''),
    /** 最終更新日終了 */
    update_at_to: yup.string().default(''),
    // service_spec_table?: boolean;
    /** 事前定型質問が必要フラグ */
    service_spec_table: yup.boolean().default(false),
    // tos?: boolean;
    /** その他トス情報が必要フラグ */
    tos: yup.boolean().default(false),
    // hg_check_require?: boolean;
    /** 開発部門確認フラグ */
    hg_check_require: yup.boolean().default(false),
    // fsr_id_search?: boolean;
    /** FSR IDの対象PSで絞り込みフラグ */
    fsr_id_search: yup.boolean().default(false),
    // fsr_id?: string;
    /** FSR ID */
    fsr_id: yup.string().default(''),
    // next_ps_no_search?: boolean;
    /** 移行先PSNoが設定されているPSで絞り込みフラグ */
    next_ps_no_search: yup.boolean().default(false),
    // next_ps_no?: string;
    /** 移行先PSNo. */
    next_ps_no: yup.string().default(''),
    // content_type_body?: boolean;
    /** テキスト分類 本文 */
    content_type_body: yup.boolean().default(false),
    // content_type_body_sup?: boolean;
    /** テキスト分類 本文補足 */
    content_type_body_sup: yup.boolean().default(false),
    // content_type_work?: boolean;
    /** テキスト分類 作動する条件 */
    content_type_work: yup.boolean().default(false),
    // content_type_not_work?: boolean;
    /** テキスト分類 作動しない条件 */
    content_type_not_work: yup.boolean().default(false),
    // content_type_custom?: boolean;
    /** テキスト分類 カスタマイズ */
    content_type_custom: yup.boolean().default(false),
    // content_type_notice?: boolean;
    /** テキスト分類 注意・警告 */
    content_type_notice: yup.boolean().default(false),
    // content_type_instruct?: boolean;
    /** テキスト分類 指示事項 */
    content_type_instruct: yup.boolean().default(false),
    // content_type_case?: boolean;
    /** テキスト分類 こんなときは */
    content_type_case: yup.boolean().default(false),
  }
);

// 編集対象の項目のデフォルト値は、仕様書に記載されている場合はその値とし、そうでない場合はそれぞれの型の予想される初期値 (boolean なら false) とする。string は null でもよい。編集しないものは null か、省くか？

// バリデーション用 & デフォルト値用。
/** テキスト確定条件用の yup の Schema。 */
export const psTextConditionSchema = yup.object().shape({
  // /**
  //  * テキスト確定条件
  //  */
  // export interface PsTextCondition {
  //   /** テキスト確定条件ID */
  //   text_condition_id?: number;
  //   /** テキスト確定条件 */
  //   text_condition?: string;
  //   /** 固有ID */
  //   unique_id?: string;
  //   /** テキスト確定条件図面情報の配列 */
  //   text_condition_drawings?: PsTextConditionDrawing[];
  //   /** テキスト確定条件FLISTの配列 */
  //   text_condition_flists?: PsTextConditionFlist[];
  //   /** サービススペック表 */
  //   service_spec_table?: string;
  //   /** その他トス情報 */
  //   tos?: string;
  //   /** その他トス情報補足説明 */
  //   tos_supplement?: string;
  //   /** 開発部門確認 */
  //   hg_check_require?: boolean;
  // }
  /** テキスト確定条件ID */
  text_condition_id: yup.number().nullable().default(null),
  /** テキスト確定条件 */
  text_condition: yup.string().default(null).required(),
  /** 固有ID */
  unique_id: yup.string().nullable().default(null),
  /** テキスト確定条件図面情報の配列 */
  text_condition_drawings: yup
    .array()
    .of(
      yup.object().shape({
        // /**
        //  * テキスト確定条件図面情報
        //  */
        // export interface PsTextConditionDrawing {
        //   /** PSテキスト確定条件図面情報ID */
        //   text_condition_drawing_id?: number;
        //   /** 図面ID */
        //   drawing_id?: number;
        //   /** 図面番号 */
        //   dwg_no?: string;
        //   /** 補足説明 */
        //   supplement?: string;
        // }
        /** PSテキスト確定条件図面情報ID */
        text_condition_drawing_id: yup.number().nullable().default(null),
        /** 図面ID */
        drawing_id: yup.number().nullable().default(null),
        // ↓ 半角英数 5 桁。
        /** 図面番号 */
        dwg_no: yup.string().nullable().default(null).length(5),
        /** 補足説明 */
        supplement: yup.string().nullable().default(null),
      })
    )
    .nullable()
    .default([]),
  /** テキスト確定条件FLISTの配列 */
  text_condition_flists: yup
    .array()
    .of(
      yup.object().shape({
        // /**
        //  * FLIST
        //  */
        // export interface PsTextConditionFlist {
        //   /** PSテキスト確定条件FLISTID */
        //   text_condition_flist_id?: number;
        //   /** Section */
        //   section?: string;
        //   /** Feature */
        //   feature?: string;
        //   /** Item */
        //   item?: string;
        // }
        /** PSテキスト確定条件FLIST ID */
        text_condition_flist_id: yup.number().nullable().default(null),
        /** Section */
        section: yup.string().nullable().default(null),
        /** Feature */
        feature: yup.string().nullable().default(null),
        /** Item */
        item: yup.string().nullable().default(null),
      })
    )
    .nullable()
    .default([]),
  /** サービススペック表 */
  service_spec_table: yup.string().nullable().default(null),
  /** その他トス情報 */
  tos: yup.string().nullable().default(null),
  /** その他トス情報補足説明 */
  tos_supplement: yup.string().nullable().default(null),
  /** 開発部門確認 */
  hg_check_require: yup.boolean().default(false),
});

export type PsTextConditionSchemaType = InferType<typeof psTextConditionSchema>;

// バリデーション用 & デフォルト値用。
/** タッチアップ用の yup の Schema。 */
export const psTouchupSchema = yup.object().shape({
  // /**
  //  * PSタッチアップ項目
  //  */
  // export interface PsTouchup {
  //   /** PSタッチアップ項目ID */
  //   touchup_id?: number;
  //   /** タッチアップ項目 */
  //   touch_up?: string;
  //   /** 判断情報 */
  //   judgement_information?: string;
  //   /** 固有ID */
  //   unique_id?: string;
  //   /** タッチアップ項目対象の配列(0:日,1:米,2:英) */
  //   touchup_targets?: PsTouchupTarget[];
  // }
  /** PSタッチアップ項目ID */
  touchup_id: yup.number().nullable().default(null),
  /** タッチアップ項目 */
  touch_up: yup.string().default(null).required(),
  /** 判断情報 */
  judgement_information: yup.string().default(null).required(),
  /** 固有ID */
  unique_id: yup.string().nullable().default(null),
  /** タッチアップ項目対象の配列(0:日,1:米,2:英) */
  touchup_targets: yup
    .array()
    .of(
      yup.object().shape({
        // /**
        //  * タッチアップ項目対象
        //  */
        // export interface PsTouchupTarget {
        //   /** タッチアップ項目対象ID */
        //   touchup_target_id?: number;
        //   /** タッチアップ対象 */
        //   target?: string;
        //   /** 書換単語候補の配列 */
        //   touchup_candidates?: PsTouchupCandidate[];
        // }
        /** タッチアップ項目対象ID */
        touchup_target_id: yup.number().nullable().default(null),
        /** タッチアップ対象 */
        target: yup.string().nullable().default(null),
        /** 書換単語候補の配列 */
        touchup_candidates: yup
          .array()
          .of(
            yup.object().shape({
              // /**
              //  * タッチアップ項目書換単語候補
              //  */
              // export interface PsTouchupCandidate {
              //   /** PSタッチアップ項目書換単語候補ID */
              //   touchup_candidate_id?: number;
              //   /** 書換単語候補 */
              //   candidate?: string;
              // }
              /** PSタッチアップ項目書換単語候補ID */
              touchup_candidate_id: yup.number().nullable().default(null),
              /** 書換単語候補 */
              candidate: yup.string().nullable().default(null),
            })
          )
          .nullable()
          .default([]),
      })
    )
    .nullable()
    .default([]),
});

export type PsTouchupSchemaType = InferType<typeof psTouchupSchema>;

// TODO?: boolean は 1 / 0 に transform?

// バリデーション用 & デフォルト値用。
/** PS 用の yup の Schema。 */
export const psSchema = yup.object().shape(
  // Ps の定義は /src/frontend/app/src/api/model/ps.ts を参照。
  {
    /** PSバージョンID */
    ps_version_id: yup.number().nullable().default(null),
    /** PS ID */
    ps_id: yup.number().nullable().default(null),
    /** PS管理No */
    ps_no: yup.string().nullable().default(null),
    /** PSバージョン番号 */
    version_no: yup.number().nullable().default(null),
    /** ステータス(0:改廃案,1:承認済み) */
    state: yup.number().nullable().default(null),
    /** 親PSバージョンID */
    parent_ps_version_id: yup.number().nullable().default(null),
    /** 公開日時 */
    release_at: yup.string().nullable().default(null),
    /** タイトルレベル */
    level: yup.number().nullable().default(null),
    /** PS種別 */
    type: yup.number().nullable().default(null),
    /** 安全表示 */
    text_type: yup
      .number()
      .transform((currentValue) => (Number.isNaN(Number(currentValue)) ? null : Number(currentValue)))
      .nullable()
      .default(null),
    /** 安全表示（自由記述） */
    text_type_description: yup.string().nullable().default(null),
    /** 表形式フラグ */
    table_exist: yup.boolean().default(false),
    /** 重要度 */
    importance: yup.string().nullable().default(null),
    /** 機種固有フラグ */
    specific: yup.boolean().default(false),
    /** 反映必須項目フラグ */
    reflect_require: yup.boolean().default(false),
    /** 記載内容分類 */
    content_type: yup
      .number()
      .transform((currentValue) => (Number.isNaN(Number(currentValue)) ? null : Number(currentValue)))
      .nullable()
      .default(null),
    // ↓ 入力不可。PS 内の派生コンテンツにイラストが含まれるかどうかを改廃案保存時にチェックしてこの値をセットする。
    /** イラストフラグ */
    illust_exist: yup.boolean().default(false),
    /** 大きいイラストフラグ */
    large_illust_exist: yup.boolean().default(false),
    /** イラストの横に回り込むイラストフラグ */
    illust_side_text_exist: yup.boolean().default(false),
    // ↓ 編集しない。
    /** 廃止フラグ(0:廃止済みではない,1:廃止済み) */
    deleted_flag: yup.boolean().nullable().default(null),
    /** 開発部門担当室課 */
    hgt_section: yup.string().nullable().default(null),
    /** 開発部門担当者名 */
    hgt_person: yup.string().nullable().default(null),
    /** 開開発部門質問カテゴリ */
    hgt_category: yup.string().nullable().default(null),
    /** 移行先PS管理No. */
    next_ps_no: yup.string().nullable().default(null),
    /** FSR ID */
    fsr_id: yup.string().nullable().default(null),
    // L1 PS のみ表示。新規作成時のみ必須入力とする。
    /** 管理No.接頭語 */
    ps_no_prefix: yup
      .string()
      .nullable()
      .default(null)
      .when('type', {
        is: 1,
        // t() はここではまだ使えないので、特定の string にしておき、エラー メッセージ表示時に置き換えることにする。
        then: (schema) => schema.required('ps_no_prefix.required()'),
      }),
    // derivations?: PsDerivation[];
    /** 派生の配列 */
    derivations: yup
      .array()
      .of(
        yup.object().shape({
          // /**
          //  * PS派生
          //  */
          // export interface PsDerivation {
          //   /** PS派生ID */
          //   derivation_id?: number;
          //   /** 固有ID */
          //   unique_id?: string;
          //   /** 派生コンテンツの配列(0:日,1:米,2:英) */
          //   derivation_contents?: PsDerivationContent[];
          //   /** 派生判定の配列 */
          //   derivation_judgements?: PsDerivationJudgement[];
          // }
          /** PS派生ID */
          derivation_id: yup.number().nullable().default(null),
          /** 固有ID */
          unique_id: yup.string().nullable().default(null),
          /** 派生コンテンツの配列(0:日,1:米,2:英) */
          derivation_contents: yup
            .array()
            .of(
              yup.object().shape({
                // /**
                //  * PS派生コンテンツ
                //  */
                // export interface PsDerivationContent {
                //   /** PS派生コンテンツID */
                //   derivation_content_id?: number;
                //   /** 代表例フラグ */
                //   represent?: boolean;
                //   /** 記載不要フラグ */
                //   unnecessary?: boolean;
                //   /** コンテンツXML */
                //   content_xml?: string;
                //   /** 編集用コンテンツXML */
                //   content_xml_edit?: string;
                //   /** コンテンツテキスト */
                //   content_text?: string;
                // }
                /** PS派生コンテンツID */
                derivation_content_id: yup.number().nullable().default(null),
                /** 代表例フラグ */
                represent: yup.boolean().default(false),
                /** 記載不要フラグ */
                unnecessary: yup.boolean().default(false),
                /** コンテンツXML */
                content_xml: yup.string().nullable().default(null),
                /** 編集用コンテンツXML */
                content_xml_edit: yup.string().nullable().default(null),
                /** コンテンツテキスト */
                content_text: yup.string().nullable().default(null),
              })
            )
            .nullable()
            .default([]),
          /** 派生判定の配列 */
          derivation_judgements: yup
            .array()
            .of(
              yup.object().shape({
                // /**
                //  * PS派生判定
                //  */
                // export interface PsDerivationJudgement {
                //   /** PS派生判定ID */
                //   derivation_judgement_id?: number;
                //   /** PSテキスト確定条件ID */
                //   ps_text_condition_id?: number;
                //   /** 判定値 */
                //   value?: number;
                // }
                /** PS派生判定ID */
                derivation_judgement_id: yup.number().nullable().default(null),
                /** PSテキスト確定条件ID */
                ps_text_condition_id: yup.number().nullable().default(null),
                /** 判定値 */
                value: yup.number().nullable().default(null),
              })
            )
            .nullable()
            .default([]),
        })
      )
      // 最低 １ つは登録されている必要がある。
      // t() はここではまだ使えないので、特定の string にしておき、エラー メッセージ表示時に置き換えることにする。
      .min(1, 'derivations.min(1)')
      // ルート PS、章 (L1) PS の場合は、派生は １ つのみしか登録出来ない。
      .when('type', {
        is: (type: number | null) => Number(type) <= 1,
        then: (schema) => schema.max(1),
      })
      .test("check represent ja", "represent.check.ja", derivations => derivations?.find(derivation => derivation.derivation_contents?.[0]?.represent) !== undefined)
      .test("check represent us", "represent.check.us", derivations => derivations?.find(derivation => derivation.derivation_contents?.[1]?.represent) !== undefined)
      .test("check represent en", "represent.check.en", derivations => derivations?.find(derivation => derivation.derivation_contents?.[2]?.represent) !== undefined)
      .default([]),
    /** テキスト確定条件の配列 */
    // text_conditions?: PsTextCondition[];
    text_conditions: yup
      .array()
      .of(psTextConditionSchema)
      .when('type', {
        is: (type: number | null) => Number(type) > 1,
        // 最低 1 つは登録されている必要がある。
        // t() はここではまだ使えないので、特定の string にしておき、エラー メッセージ表示時に置き換えることにする。
        then: (schema) => schema.min(1, 'text_conditions.min(1)'),
        // ただしルート PS と章 (L1) PS の場合は、テキスト確定条件は登録出来ない。
        // TODO?: max(0) ではなく、null とする？
        otherwise: (schema) => schema.max(0),
      })
      .nullable()
      .default([]),
    /** タッチアップ項目の配列 */
    // touchups?: PsTouchup[];
    touchups: yup
      .array()
      .of(psTouchupSchema)
      .when('type', {
        is: (type: number | null) => Number(type) <= 1,
        // ルート PS と章 (L1) PS の場合は登録出来ない。
        then: (schema) => schema.max(0),
      })
      .nullable()
      .default([]),
    /** 記載が必要な理由 */
    description_reason: yup.string().nullable().default(null),
    /** 制作で押さえるポイント */
    description_key_point: yup.string().nullable().default(null),
    /** HM内情報共有欄 */
    hm_share: yup.string().nullable().default(null),
    /** 抜粋ステータス(日米英) */
    excerpt_status_id_ja: yup.number().default(0),
    excerpt_status_id_us: yup.number().default(0),
    excerpt_status_id_en: yup.number().default(0),
    /** 法規情報の配列(0:日,1:米,2:英) */
    // legal_informations?: PsLegalInformation[];
    legal_informations: yup
      .array()
      .of(
        yup.object().shape({
          // /**
          //  * PS法規情報
          //  */
          // export interface PsLegalInformation {
          //   /** PS法規情報ID */
          //   legal_information_id?: number;
          //   /** 法規(Varbatimである) */
          //   verbatim?: boolean;
          //   /** Varbatimタグ */
          //   verbatim_tag?: boolean;
          //   /** 法規番号(法規情報) */
          //   information?: string;
          //   /** 法規メモ(備考) */
          //   note?: string;
          //   /** 法規適用国の配列 */
          //   legal_regions?: PsLegalRegion[];
          // }
          /** PS法規情報ID */
          legal_information_id: yup.number().nullable().default(null),
          /** 法規(Varbatimである) */
          verbatim: yup.boolean().default(false),
          /** Varbatimタグ */
          verbatim_tag: yup.boolean().default(false),
          /** 法規番号(法規情報) */
          information: yup.string().nullable().default(null),
          /** 法規メモ(備考) */
          note: yup.string().nullable().default(null),
          /** 法規適用国の配列 */
          legal_regions: yup
            .array()
            .of(
              yup.object().shape({
                // /**
                //  * PS法規適用国
                //  */
                // export interface PsLegalRegion {
                //   /** PS法規適用国・グループID */
                //   ps_legal_region_id?: number;
                //   /** 法規適用国・グループID */
                //   legal_region_id?: number;
                //   /** 法規適用国・グループ名 */
                //   legal_region_name?: string;
                // }
                /** PS法規適用国・グループID */
                ps_legal_region_id: yup.number().nullable().default(null),
                /** 法規適用国・グループID */
                legal_region_id: yup.number().nullable().default(null),
                /** 法規適用国・グループ名 */
                legal_region_name: yup.string().nullable().default(null),
              })
            )
            .nullable()
            .default([]),
        })
      )
      .nullable()
      .default([]),
    /** WebOM記載の配列(0:日,1:米,2:英) */
    webom_descriptions: yup.array().of(yup.string().nullable()).nullable().default(null),
    /** dOM記載の配列(0:日,1:米,2:英) */
    dom_descriptions: yup.array().of(yup.string().nullable()).nullable().default(null),
    /** dOM記載キーワードの配列(0:日,1:米,2:英) */
    dom_search_keywords: yup.array().of(yup.string().nullable()).nullable().default(null),
    // ↓ 編集しない。
    /** 最新フラグ */
    latest: yup.boolean().nullable().default(null),
    // ↓ 編集しない。
    /** PSバージョン履歴の配列 */
    // ps_version_histories?: PsVersionHistory[];
    ps_version_histories: yup.array().nullable().default([]),
    // TODO?: PsTreeItem の schema にする？
    /** 子要素の配列(ツリー編集時のみ) */
    // child_tree_items?: PsTreeItem[];
    child_tree_items: yup.array().nullable().default([]),
  }
);

export type PsSchemaType = InferType<typeof psSchema>;
